import { render, staticRenderFns } from "./TituloPrincipal.vue?vue&type=template&id=77933247&scoped=true"
import script from "./TituloPrincipal.vue?vue&type=script&lang=js"
export * from "./TituloPrincipal.vue?vue&type=script&lang=js"
import style0 from "./TituloPrincipal.vue?vue&type=style&index=0&id=77933247&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77933247",
  null
  
)

export default component.exports